import styled from 'styled-components';
import { DataCy } from '../../../../types/dataAttributes';
import { cssStyledInput } from '../JRCStyledInput';

export const JRCInputTextareaRaw = styled.textarea.attrs<
    DataCy & { height?: string },
    {
        height?: string;
    }
>(({ dataCy, height }) => ({ 'data-cy': dataCy, height }))`
    ${cssStyledInput}
    &&&& {
        padding-top: 10px;
        height: ${({ height }) => height ?? '140px'};
        resize: vertical;
    }

    &&&&:read-only,
    &&&&:disabled {
        resize: none;
    }
`;
